import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "filters-selections__label"
}

import {formatText} from "@shared/utils/format-text";


export default /*@__PURE__*/_defineComponent({
  __name: 'Selections',
  props: {
    label: {},
    values: {},
    small: { type: Boolean },
    formatValues: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const getValueText = (value: string): string => props.formatValues ? formatText(value) : value;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-selections", {'filter-selections--small': __props.small}])
  }, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(__props.label), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.values, (value) => {
      return (_openBlock(), _createElementBlock("span", {
        key: value,
        class: "filter-selections__value"
      }, _toDisplayString(getValueText(value)), 1 /* TEXT */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}
}

})